import React from 'react'
import { Box, SimpleGrid, VStack, Spinner, Button } from '@chakra-ui/react'

interface Classes {
  title: any
  subtitle: any
  wrapper?: any
}

interface InformativeLayerProps {
  title: React.ReactNode
  paragraph?: React.ReactNode
  image: React.ReactNode
  action?: () => any
  isLoading?: boolean
  classes?: Classes
  textButton?: string
  variantButton?: string
  support?: React.ReactNode
}

const InformativeLayer: React.FC<InformativeLayerProps> = ({
  title,
  paragraph,
  image,
  action,
  isLoading = false,
  textButton,
  variantButton,
  support,
}) => (
  <SimpleGrid data-testid='info-grid' columns={1} overflowY='auto' maxH='calc(100vh - 96px)'>
    <VStack data-testid='info-centert-offset'  h={222} p={24} mt={['157px','257px']} gap='16px' justifyContent='center'>
      <Box data-testid='info-image' h={96} textAlign='center'  justifyContent='center'>
        { isLoading && (<Spinner data-testid='info-spinner' variant="default" />)}
        { !isLoading && (image)}        
      </Box>        
      <Box data-testid='info-title' h={32} mt='0px' textAlign='center' >
        {title}
      </Box>
      <Box data-testid='info-paragraph' h={32} p={[0, 0, 16, 0]} >
        {paragraph}
      </Box>      
    {typeof action === 'function' && !isLoading && variantButton && textButton && (
      <Box data-testid='info-action' h={24}>
        <Button data-testid='info-button' variant={variantButton} size={'lg'} minW='204px' onClick={() => action()}>
          {' '} {textButton} {' '}
         </Button>
      </Box>
    )}
      {support}
    </VStack>
  </SimpleGrid>
)

export default InformativeLayer
